// Port aus chat/PhaseProgress.svelte — ruhige Statuszeile fuer den Wissens-Modus.
export type Phase = 'plan' | 'search' | 'synthesis';
const TEXT: Record<Phase, string> = { plan: 'Suche wird vorbereitet …', search: 'Suche in medizinischen Quellen …', synthesis: 'Antwort wird zusammengestellt …' };
export default function PhaseProgress({ phase }: { phase: Phase | null; plan?: Record<string, string> | null; sources?: unknown[] }) {
  if (!phase) return null;
  return (
    <div className="card mb-3 ml-4 inline-flex items-center gap-2.5 px-4 py-3">
      <span className="h-3 w-3 animate-spin rounded-full border-[1.6px] border-primary-200 border-t-primary-500" />
      <span className="text-[12.5px] font-medium text-ps-dark-900">{TEXT[phase]}</span>
    </div>
  );
}
